import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps } from '@apply/ui';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';

const AcquisitionFinancing: React.FC<PageQuestionProps> = ({ onQuestionValidate, submitted, property, onChange, required }) => {
    return (
        <div className='form-group'>
            <div className='row'>
                <Question
                    type={QuestionType.YesNo}
                    submitted={submitted}
                    selector='isAquisitionFinancing'
                    styleName='ungrouped'
                    onQuestionValidate={onQuestionValidate}
                    value={property.nonRental?.isAquisitionFinancing}
                    onChangeQualifier={property.guid}
                    onChange={onChange}
                    required={required}
                >
                    Is funding required at closing?
                </Question>
                <span
                    className='helper'
                    style={{ left: '15rem' }}
                >
                    <span className='tooltip-trigger'>
                        <FontAwesomeIcon icon={faCircleQuestion} />
                    </span>
                    <span className='text'>Funding is financing provided at the time of purchase.</span>
                </span>
            </div>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChange: (guid: string, value: boolean) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChange: (guid: string, value: boolean) =>
            dispatch(Store.PropertiesStore.Actions.updateIsAquisitionFinancing(guid, value)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(AcquisitionFinancing);
